/* eslint camelcase: 0 */
import { Company } from '@/infrastructure/network/Monitaro/schema/models'
import { ICompanyProps, EmptyCompanyPropsFactory } from '@/entities/Company'

export const toCompanyProps = (props: Company | null | undefined): ICompanyProps => {
  if (!props) {
    return EmptyCompanyPropsFactory()
  }

  const { id, industries, name, kana, properties, created_at, updated_at } = props

  return EmptyCompanyPropsFactory({
    id,
    industries,
    name,
    kana,
    properties,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
